module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav border"
  }, [_c('div', {
    staticClass: "labeldiv top",
    staticStyle: {
      "margin-left": "0.5rem",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.query.label))]), _vm._v(" "), (_vm.id !== 20) ? _c('div', {
    staticClass: "top",
    staticStyle: {
      "float": "right",
      "margin-bottom": "0rem",
      "height": "0.8rem"
    }
  }, [(!_vm.showSearchBar) ? _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), (_vm.id === 3 || _vm.id === 2 || _vm.id === 12 || _vm.id === 1) ? _c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "background-color": "#F6F6F7"
    },
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入基因名称...",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  }) : (_vm.id === 6) ? _c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "background-color": "#F6F6F7"
    },
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入细胞名称...",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  }) : _c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "background-color": "#F6F6F7"
    },
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  })]) : _vm._e()]) : _c('div', {
    staticClass: "top",
    staticStyle: {
      "float": "right",
      "margin-bottom": "0rem",
      "height": "0.8rem"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'finder'
      }
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入基因名称...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content top"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "3rem",
      "overflow": "scroll",
      "height": "100%"
    },
    style: ({
      'margin-bottom': _vm.emkt.leaveSpaceForFullScreen ? '4rem' : '3rem'
    })
  }, [_c('newMerchandiseListA', {
    attrs: {
      "merchList": _vm.catagoryList,
      "showFilterBar": _vm.showSearchBar,
      "showFilterBarForKit": _vm.showFilterBarForKit
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c70f140e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Category/CategoryDetail.vue
// module id = 1721
// module chunks = 8